import React from "react";
import MasterData from "view/settings/masterdata/MasterData";
const OperatingCostData = () => {
   
    const sections = [
        { label: "Opex Type", value: "OpexType", items: [] },
    ];
   

    return (
        <>
            <MasterData pageTitle="OperatingCost" sections={sections} />
        </>

    );
};

export default OperatingCostData;